// material
import { Container } from '@mui/material';

// componente
import Page from '../../components/Page';
// layout
import ModuloChat from '../../layouts/chat';
import { useWSContext } from '../../contexts/WebSocketContext';

function Chat() {
  const { supportName } = useWSContext();

  return (
    <Page title={`Chat: ${supportName} | Tecnozap`}>
      <Container>
        <ModuloChat />
      </Container>
    </Page>
  );
}

export default Chat;
